// extracted by mini-css-extract-plugin
export default {"tooltip":"bS-z","arrow":"cS-z"};